import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n.js";
import "./axiosConfig.js";
import { Workbox } from "workbox-window";
import { HelmetProvider } from 'react-helmet-async';

// Suppress ResizeObserver loop error (not critical, happens with MUI components)
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop completed with undelivered notifications|ResizeObserver loop limit exceeded)]/;
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && resizeObserverLoopErrRe.test(args[0])) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register Workbox service worker
if ('serviceWorker' in navigator) {
  const wb = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`);

  // Prevent infinite refresh loops
  const MAX_REFRESH_COUNT = 3;
  const REFRESH_COUNT_KEY = 'sw_refresh_count';
  const REFRESH_TIMESTAMP_KEY = 'sw_refresh_timestamp';
  
  wb.addEventListener('installed', (event) => {
    if (event.isUpdate) {
      // Check if we're in a refresh loop
      const now = Date.now();
      const lastRefresh = parseInt(localStorage.getItem(REFRESH_TIMESTAMP_KEY) || '0');
      const refreshCount = parseInt(localStorage.getItem(REFRESH_COUNT_KEY) || '0');
      
      // Reset counter if last refresh was more than 5 minutes ago
      if (now - lastRefresh > 5 * 60 * 1000) {
        localStorage.setItem(REFRESH_COUNT_KEY, '0');
      }
      
      // Prevent infinite refresh loop
      if (refreshCount >= MAX_REFRESH_COUNT) {
        console.warn('Refresh loop detected. Skipping auto-refresh. Please clear cache manually.');
        // Clear the counter after 10 minutes
        setTimeout(() => {
          localStorage.setItem(REFRESH_COUNT_KEY, '0');
        }, 10 * 60 * 1000);
        return;
      }
      
      // New content is available, tell the user
      if (window.confirm("تحديث جديد متاح! هل تريد التحديث؟\nNew update available! Do you want to refresh?")) {
        localStorage.setItem(REFRESH_COUNT_KEY, (refreshCount + 1).toString());
        localStorage.setItem(REFRESH_TIMESTAMP_KEY, now.toString());
        window.location.reload();
      }
    } else {
      console.log("Content is cached for offline use.");
    }
  });

  wb.register().catch((error) => {
    console.error("Error during service worker registration:", error);
    // If service worker fails to register, clear cache
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }
  });
}
